<textarea
  class="form-control"
  [class.is-invalid]="showError"
  [formControl]="$any(formControl)"
  [rows]="props.rows ?? 3"
  [formlyAttributes]="field"
  [attr.data-testid]="props.testId"
></textarea>
